<script>
import accountMixin from "@/mixins/accountMixin";

export default {
  mixins: [accountMixin],
  props: {
    account: {
      type: Object,
      required: true
    }
  }
};
</script>

<template>
  <v-tooltip open-delay="0" close-delay="0" right>
    <template v-slot:activator="{ on }">
      <v-chip v-on="on" align-center>
        <v-avatar left size="35px">
          <img :src="account.profile.profile_picture" alt="avatar" />
        </v-avatar>
        <span class="text-capitalize text-truncate">{{
          account | fullName
        }}</span>
      </v-chip>
    </template>

    <span class="text-capitalize">{{ account | fullName }}</span>
  </v-tooltip>
</template>

<style scoped>
span {
  max-width: 150px;
  font-size: 13px;
}
</style>



// WEBPACK FOOTER //
// src/components/_Shared/Users/Profile/Row.vue